module.exports = __webpack_public_path__ + "img/11.0271c140.webp";